import { CKEditor, CKEditorEventHandler } from 'ckeditor4-react';

function TextEditor(props: {
  placeholder: string;
  name: string;
  value: string;
  onChange: CKEditorEventHandler<'change'>;
  onBlur: CKEditorEventHandler<'blur'>;
  height?: string;
  initData?: string;
}) {
  const { name, value, onChange, onBlur, placeholder, height } = props;
  return (
    <CKEditor
      initData={props.initData}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      config={{
        enterMode: 2,
        shiftEnterMode: 2,
        autoParagraph: false,
        removePlugins: 'elementspath, resize',
        extraPlugins: 'editorplaceholder',
        contentsCss: '',
        height: height ? height : '125',
        toolbar: [
          { name: 'clipboard', items: ['Undo', 'Redo'] },
          { name: 'basicstyles', items: ['Bold', 'Italic'] },
          {
            name: 'paragraph',
            items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent'],
          },
          { name: 'links', items: ['Link'] },
          { name: 'insert', items: ['Image'] },
        ],
        autoGrow_maxHeight: '125',
        editorplaceholder: placeholder,
        toolbarLocation: 'bottom',
        fontSize_defaultLabel: '14px',
        fontFamily: {
          options: [
            'default',
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
          ],
        },
      }}
    />
  );
}

export default TextEditor;
